import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import DrawerCloseIcon from '../DrawerCloseIcon';
import DrawerTitle from '../DrawerTitle';

function DrawerHeader({ children, onClose, title }) {
	const displayTitle = Boolean(title);
	const hasChildren = Boolean(children);
	const leftContent = displayTitle ? (
		<DrawerTitle>{title}</DrawerTitle>
	) : (
		children
	);
	const middleContent = displayTitle && hasChildren ? children : null;

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				px: 2,
				pt: 1.5,
				pb: 0.5,
				gap: 2,
				borderBottom: 1,
				borderColor: 'divider',
			}}
		>
			<Box sx={{ minWidth: 0, flex: 1 }}>{leftContent}</Box>

			<Box
				sx={{
					display: middleContent ? 'flex' : 'none',
					justifyContent: 'flex-end',
					alignItems: 'center',
					minWidth: 0,
					flexShrink: 0,
				}}
			>
				{middleContent}
			</Box>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'flex-end',
					alignItems: 'center',
					flexShrink: 0,
				}}
			>
				<DrawerCloseIcon
					onClose={onClose}
					role="graphics-symbol"
					aria-hidden="true"
				/>
			</Box>
		</Box>
	);
}

DrawerHeader.propTypes = {
	onClose: PropTypes.func.isRequired,
	children: PropTypes.any,
	title: PropTypes.any,
};

export default React.memo(DrawerHeader);
